import React, { Component } from 'react';
import { Link, NavLink, withRouter } from "react-router-dom";
import _ from 'underscore';

import BookmarkButton from './BookmarkButton';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class NofnislendingaView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/nofn_islendinga/';

		this.state = {
			loading: false
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		let params = [];

		this.setState({
			loading: true
		});

		fetch(this.url+'greinar/'+this.props.match.params.id)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					loading: false
				});

				fetch(this.url+'?offset='+(json.nafn[0].rownum-10))
					.then(res => res.json())
					.then(indexJson => this.setState({ordIndex: indexJson.results}))
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'}>

				<div className={'col col-9'}>
					<div className={'column-content'+(this.state.loading ? ' loading' : '')}>
						{
							item &&
							<React.Fragment>

								<BreadCrumbs path={[
									{
										path: '/nofnislendinga/',
										title: 'Nöfn Íslendinga'
									},
									{
										path: item.id,
										title: item.nafn[0].nafn
									}
								]} />

								<h3 dangerouslySetInnerHTML={{__html: item.nafn.map((n, i) => i > 0 ? '<i>'+n.nafn+'</i>' : n.nafn).join(', ')+(item.nafn[0].ofl ? ' <small>'+item.nafn[0].ofl+'</small>' : '')+(item.nafn[0].beyging ? ' <small><i>('+item.nafn[0].beyging+')</i></small>' : '')}} />

								<div className="row">
									<div className="col col-12">
										{
											item.texti && <div dangerouslySetInnerHTML={{__html: item.texti.replace('\n', '<br/>') }} />
										}
										{
											item.visun && <div>Ritháttur af <NavLink to={'/nofnislendinga/'+item.visun.grein}><em>{item.visun.nafn}</em></NavLink></div>
										}
										{
											item.sja && <div>&rarr; <NavLink to={'/nofnislendinga/'+item.sja.grein}><em>{item.sja.nafn}</em></NavLink></div>
										}
									</div>

								</div>

							</React.Fragment>
						}
					</div>
				</div>

				<div className={'col col-3'}>
					{
						this.state.ordIndex && <table className="table table">
							<tbody>
								{
									this.state.ordIndex.map((item, index) => <tr><td><NavLink activeClassName="font-weight-bold" to={'/nofnislendinga/'+item.grein}>{item.nafn}</NavLink></td></tr>)
								}
							</tbody>
						</table>
					}
				</div>

			</div>
		);
	}
}

export default withRouter(NofnislendingaView);



// WEBPACK FOOTER //
// ./src/components/NofnislendingaView.js